import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { setGoogleDriveScopeGranted } from "../../client/api";
import { useNotification } from "../../context/NotificationContext";

const GoogleDriveCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { addNotification } = useNotification();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const driveScopeUpgrade = urlParams.get("drive_scope_upgrade");
    const googleToken = urlParams.get("google_token");

    if (driveScopeUpgrade === "success" && googleToken) {
      // Only the Google token is needed; the login token stays as it is.
      localStorage.setItem("google_access_token", googleToken);

      setGoogleDriveScopeGranted();
      addNotification(
        "Google Drive access granted successfully! You can now upload your video.",
        "success"
      );

      // Get the stored redirect path or default to "/projects"
      const redirectPath =
        localStorage.getItem("drive_redirect_path") || "/projects";

      // Clean up the stored path
      localStorage.removeItem("drive_redirect_path");

      // Navigate to the stored path with success parameter
      navigate(`${redirectPath}?drive_connected=true`);

      window.history.replaceState({}, document.title, window.location.pathname);
    } else {
      const error = searchParams.get("error");

      // Get the stored redirect path or default to "/projects"
      const redirectPath =
        localStorage.getItem("drive_redirect_path") || "/projects";

      // Clean up the stored path
      localStorage.removeItem("drive_redirect_path");

      if (error) {
        navigate(`${redirectPath}?drive_error=true`);
      } else {
        navigate(`${redirectPath}?drive_connected=true`);
      }
    }
  }, [searchParams, navigate, addNotification]);

  return <div>Completing Google Drive connection...</div>;
};

export default GoogleDriveCallback;
